import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { useGeolocation } from 'state/geolocation';
import { primitive } from 'styles/constants/primitives';

import { ResetLocationButton } from '../../reset-location-button';

import { IMapButtonsProps } from './types';

/**
 *
 * MapButtons handles logic & UI for the Search This Area
 *  and Reset Location buttons within the map container.
 *
 */
export const MapButtons: FC<React.PropsWithChildren<IMapButtonsProps>> = ({
  onCenterToUserLocation,
  hasPanned,
  isDesktop,
  onPressSearchThisArea,
  searchingNearby,
}) => {
  const { formatMessage } = useIntl();
  const { loadingUserCoordinates } = useGeolocation();

  return (
    <Box flex={1} flexDirection="row" justifyContent="center">
      <Box
        alignSelf="center"
        display={hasPanned ? 'flex' : 'none'}
        marginX="$0"
        marginTop="$0"
        testID="map-buttons"
        justifySelf="center"
        marginBottom="$2.5"
      >
        <ActionButton
          size={isDesktop ? ActionButtonSizes.LARGE : ActionButtonSizes.SMALL}
          onPress={onPressSearchThisArea}
          testID="search-this-area-button"
          variant={ActionButtonVariants.BOX_SHADOW_INVERSE}
          _pressed={{
            backgroundColor: primitive.$white,
            opacity: 0.9,
            _text: {
              color: primitive.bk.$bbqBrown,
            },
          }}
          _hover={{
            backgroundColor: primitive.$white,
            opacity: 0.9,
            _text: {
              color: primitive.bk.$bbqBrown,
            },
          }}
        >
          {formatMessage({ id: 'searchThisArea' })}
        </ActionButton>
      </Box>

      <Box position="absolute" bottom={isDesktop ? '$8' : '$7'} right={'$4'} alignSelf="flex-end">
        <ResetLocationButton
          onButtonPress={onCenterToUserLocation}
          loading={searchingNearby || loadingUserCoordinates}
        />
      </Box>
    </Box>
  );
};
